import { RegisterForm } from "./RegisterForm";
import { RegisterFormGroup } from "./RegisterFormGroup";

export const RegisterFormContainer = ({
  url,
  mode,
  category,
  name,
  password,
  phoneNumber,
  domain,
}) => {
  const renderComponentBasedOnMode = () => {
    switch (category) {
      case "individual":
        return (
          <RegisterForm
            url={url}
            mode={mode}
            category={category}
            name={name}
            phoneNumber={phoneNumber}
            password={password}
            domain={domain}
          />
        );
      case "group":
      case "club":
        return (
          <RegisterFormGroup
            url={url}
            mode={mode}
            category={category}
            name={name}
            phoneNumber={phoneNumber}
            password={password}
            domain={domain}
          />
        );
      default:
        return <div>Invalid category provided.</div>;
    }
  };

  return <div>{renderComponentBasedOnMode()}</div>;
};
